import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-frame-management',
  templateUrl: './frame-management.component.html',
  styleUrls: ['./frame-management.component.css']
})
export class FrameManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/frame-management/frame-management.component.ts